export const ru = {
    BYN: 'BYN',
    CHF: '₣',
    EUR: '€',
    KZT: '₸',
    RUB: '₽',
    TRY: '₺',
    UAH: '₴',
    USD: '$',
    UZS: 'so‘m',
    YND_FIXED: 'у.е.'
};
